<template>
  <div class="login-container">
    <div @click="home" class="close">
      <CloseIcon />
      <span class="close-text">ESC</span>
    </div>
    <LogoIcon @click="home" class="logo-icon" />
    <span class="title">Set a New Password</span>
    <div class="login-content">
      <div class="inputs">
        <div class="floating-label has-icon">
          <input
            v-model="password"
            placeholder="Enter your new password"
            type="password"
            name="password"
            id="password"
            autofocus
            autocomplete="off"
            @keyup.enter="handleEnter"
          />
          <label for="password">New Password</label>
          <div class="input-icon">
            <PasswordIcon class="icon mini" />
          </div>
        </div>
      </div>
      <!--      <div class="login">-->
      <!--        <router-link-->
      <!--          :to="{ name: 'LoginNew' }"-->
      <!--          tag="button"-->
      <!--          class="button-text"-->
      <!--          tabindex="0"-->
      <!--        >-->
      <!--          <span>Back to Sign In</span>-->
      <!--        </router-link>-->
      <!--      </div>-->
      <button
        @click="resetPassword"
        class="button-default big submit-button"
        :disabled="!password || loading"
        tabindex="0"
      >
        <span>{{ loading ? "Loading..." : "Update password" }}</span>
      </button>
      <div class="sign-up">
        <span class="signup-text">Don't have an account?</span>
        <router-link
          :to="{ name: 'Signup' }"
          tag="button"
          class="button-text"
          tabindex="0"
        >
          <span>Sign Up</span>
        </router-link>
      </div>
    </div>
    <SnackBar>
      <template v-slot:icon>
        <ErrorIcon />
      </template>
    </SnackBar>
  </div>
</template>
<script>
import LogoIcon from "@/components/AppLogo";
import CloseIcon from "../../../../public/img/icons/close.svg";
import PasswordIcon from "../../../../public/img/icons/password.svg";
import ErrorIcon from "../../../../public/img/icons/error.svg";
import { M_RESET_PASSWORD } from "@/graphql";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  components: {
    LogoIcon,
    CloseIcon,
    PasswordIcon,
    ErrorIcon,
    SnackBar
  },
  name: "ResetPasswordNew",
  data() {
    return {
      token: null,
      password: null,
      loading: false
    };
  },
  mounted() {
    localStorage.setItem("token", "");
    // this.$store.dispatch("setUser", null);
    // this.$store.dispatch("setArtist", null);
    this.token = this.$route.query.token;
  },
  methods: {
    async resetPassword() {
      const { token, password } = this;
      try {
        this.loading = true;
        await this.$apollo.mutate({
          mutation: M_RESET_PASSWORD,
          variables: {
            token,
            password
          }
        });
        // document.location = "/login?reset=true";
        await this.$store.dispatch("snack", {
          text: `Success! Password updated. Please log in.`
        });
        await this.home();
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: err.message.replace("GraphQL error: ", "")
        });
      } finally {
        this.loading = false;
      }
    },
    handleEnter() {
      if (!this.password || this.loading) {
        return;
      } else {
        this.resetPassword();
      }
    },
    async home() {
      await this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .close {
    cursor: pointer;
    position: fixed;
    top: 44px;
    right: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:hover {
      svg {
        path {
          fill: white;
        }
      }
      .close-text {
        color: white;
      }
    }
    svg {
      width: 18px;
      margin: 3px 0;
      path {
        fill: #8786ab;
      }
    }
    .close-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 10px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
  }
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    .inputs {
      margin-top: 30px;
      width: 100%;
      display: grid;
      grid-gap: 18px;
    }
    .forgot {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .submit-button {
      margin-top: 22px;
      width: 100%;
    }
    .sign-up {
      margin-top: 69px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .signup-text {
        margin-bottom: 10px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        /* Text/type0 */
        color: $text-type-0;
      }
    }
  }
}
</style>
